import React, { Component } from 'react'
import { connect } from 'react-redux'
import Purch3DSVaultSample from '../samples/Purch3DSVaultSample'
import { makePurchase3DSVault } from '../../../actions/mcpActions'
import { updateOrderId } from '../../../actions/commonActions'
import { _MCP, _DOTNET, _JAVA, _PHP } from '../../../actions/types'

const CODES = {
    store_ID: ["mpgReq.SetStoreId(store_id);", "mpgReq.setStoreId(store_id);", "'store_id'=>$store_id"],
    API_token: ["mpgReq.SetApiToken(api_token);", "mpgReq.setApiToken(api_token);", "'api_token'=>$api_token"],

    status_check: ["mpgReq.SetStatusCheck(status_check);", "mpgReq.setStatusCheck(status_check);", "$mpgHttpPost = new mpgHttpsPostStatus($store_id,$api_token,$status,$mpgRequest);"],
    
    data_key: ["mcpResCavvPurchaseCC.SetData(data_key);", "mcpResCavvPurchaseCC.setData(data_key);", "'data_key'=>$data_key"],
    order_ID: ["mcpResCavvPurchaseCC.SetOrderId(order_id);", "mcpResCavvPurchaseCC.setOrderId(order_id);", "'order_id'=>$order_id"],
    credit_card_number: ["mcpResCavvPurchaseCC.SetPan(pan);", "mcpResCavvPurchaseCC.setPan(pan);", "'pan'=>$pan"],
    expiry_date: ["mcpResCavvPurchaseCC.SetExpdate(expiry_date);", "mcpResCavvPurchaseCC.setExpDate(expiry_date);", "'expiry_date'=>$expiry_date"],
    CAVV: ["mcpResCavvPurchaseCC.SetCavv(cavv);", "mcpResCavvPurchaseCC.setCavv(cavv);", "cavv=>$cavv"],
    electronic_commerce_indicator: ["mcpResCavvPurchaseCC.SetCryptType(crypt);", "mcpResCavvPurchaseCC.setCryptType(crypt);", "'crypt_type'=>$crypt"],

    version_number: ["mcpResCavvPurchaseCC.SetMCPVersion(\"MCP_VERSION_NUM\");", "mcpResCavvPurchaseCC.setMCPVersion(\"MCP_VERSION_NUM\");", "'mcp_version'=> $mcp_version"],
    cardholder_amount: ["mcpResCavvPurchaseCC.SetCardholderAmount(\"CARDHOLDER_AMOUNT\");", "mcpResCavvPurchaseCC.setCardholderAmount(\"CARDHOLDER_AMOUNT\");", "'cardholder_amount' => $cardholder_amount"],
    cardholder_currency_code: ["mcpResCavvPurchaseCC.SetCardholderCurrencyCode(\"CARDHOLDER_CURRENCY_CODE\");", "mcpResCavvPurchaseCC.setCardholderCurrencyCode(\"CARDHOLDER_CURRENCY_CODE\");", "'cardholder_currency_code' => $cardholder_currency_code"],

    TDS_version: ["mcpResCavvPurchaseCC.SetThreeDSVersion(\"ThreeDSVersion\");", "mcpResCavvPurchaseCC.setThreeDSVersion(\"ThreeDSVersion\");", "'threeds_version'=>$threeds_version"],
    server_transaction_ID: ["mcpResCavvPurchaseCC.setThreeDSServerTransId(\"ThreeDSServerTransId\");", "mcpResCavvPurchaseCC.setThreeDSServerTransId(\"ThreeDSServerTransId\");", "'threeds_server_trans_id'=>$threeds_server_trans_id"],

    customer_ID: ["mcpResCavvPurchaseCC.SetCustId(cust_id);", "mcpResCavvPurchaseCC.setCustId(cust_id);", "'cust_id'=>$cust_id"],
    dynamic_descriptor: ["mcpResCavvPurchaseCC.SetDynamicDescriptor(dynamic_descriptor);", "mcpResCavvPurchaseCC.setDynamicDescriptor(dynamic_descriptor);", "'dynamic_descriptor'=>$dynamic_descriptor"],
    Credential_Info: ["mcpResCavvPurchaseCC.SetCofInfo(cof);", "mcpResCavvPurchaseCC.setCofInfo(cof);", "$mpgTxn->setCofInfo($cof);"],
    wallet_indicator: ["mcpResCavvPurchaseCC.SetWalletIndicator(wallet_indicator);", "mcpResCavvPurchaseCC.setWalletIndicator(wallet_indicator);", "'wallet_indicator'=>$wallet_indicator"],
    AVS_Information: ["mcpResCavvPurchaseCC.SetAvsInfo(avsCheck);", "mcpResCavvPurchaseCC.setAvsInfo(avsCheck);", "$mpgTxn->setAvsInfo($mpgAvsInfo);"],
    CVD_Information: ["mcpResCavvPurchaseCC.SetCvdInfo(cvdCheck);", "mcpResCavvPurchaseCC.setCvdInfo(cvdCheck);", "$mpgTxn->setCvdInfo($mpgCvdInfo);"],
    
    DS_transaction_ID: ["mcpResCavvPurchaseCC.SetDsTransId(\"DsTransId\");", "mcpResCavvPurchaseCC.setDsTransId(\"DsTransId\");", "'ds_trans_id' => $ds_trans_id"]
}


export class PurchaseWith3DSVault extends Component {
    async generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }

    async onMakePurchaseWith3DSVault() {
        const newOrderId = await this.generateOrderId();
        this.props.updateOrderId({ featureId: _MCP, orderId: newOrderId });
        const { storeId, apiToken, expdate, amount, currency, mcpRateToken, cavv } = this.props;
        const purchase3DSVaultRequest = { storeId, apiToken, orderId: newOrderId, expdate, amount, currency, mcpRateToken, cavv };
        this.props.makePurchase3DSVault(purchase3DSVaultRequest);
    }

    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
                <h3>Sample MCP Purchase with 3-D Secure and Vault</h3>
                <Purch3DSVaultSample />
                <div className="requestButton" onClick={() => this.onMakePurchaseWith3DSVault()}>
                    MCP Purchase with 3DS and Vault Request
                </div> 
            </div>
        );
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <span className="stepPageTitle"><b>MCP Purchase with 3-D Secure</b></span>
               
                <p><b>MCP Purchase with 3-D Secure and Vault transaction object definition</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>MCPResCavvPurchaseCC mcpResCavvPurchaseCC = new MCPResCavvPurchaseCC();</code>
                    case _JAVA:
                        return <code>MCPResCavvPurchaseCC mcpResCavvPurchaseCC = new MCPResCavvPurchaseCC();</code>
                    case _PHP:
                        return <code>$txnArray = array(‘type’=>’mcp_res_purchase_cc', …);<br />$mpgTxn = new mpgTransaction($txnArray);</code>
                    default:
                        return null
                    }
                })()}

                <p style={{ marginTop: '5vh'}}><b>HttpsPostRequest object for MCP Purchase with 3-D Secure and Vault transaction</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(mcpResCavvPurchaseCC);</code>
                    case _JAVA:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(mcpResCavvPurchaseCC);</code>
                    case _PHP:
                        return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);</code>
                    default:
                        return null
                    }
                })()}

                <h3 style={{ marginTop: '7vh'}}>Core connection object fields (all API transactions)</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>store ID</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.store_ID[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>API token</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.API_token[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>Optional connection object field</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>status check</td>
                        <td><i>Boolean</i><br /><br />true/false</td>
                        <td><code>{CODES.status_check[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>MCP Purchase with 3-D Secure and Vault transaction request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>data key</td>
                        <td><i>String</i><br /><br />25-character alphanumeri</td>
                        <td><code>{CODES.data_key[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>order ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric<br /><br />a-Z A-Z 0-9 _ - : . @ spaces</td>
                        <td><code>{CODES.order_ID[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>credit card number</td>
                        <td><i>String</i><br /><br />max 20-character alphanumeric</td>
                        <td><code>{CODES.credit_card_number[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>expiry date</td>
                        <td><i>String</i><br /><br />4-character alphanumeric<br /><br />YYMM</td>
                        <td><code>{CODES.expiry_date[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>Cardholder Authentication Verification Value (CAVV)</td>
                        <td><i>String</i><br /><br />50-character alphanumeric</td>
                        <td><code>{CODES.CAVV[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>electronic commerce indicator</td>
                        <td><i>String</i><br /><br />1-character alphanumeric</td>
                        <td><code>{CODES.electronic_commerce_indicator[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>MCP-specific request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>MCP version number</td>
                        <td><i>String</i><br /><br />numeric<br /><br />current version is 1.0</td>
                        <td><code>{CODES.version_number[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>cardholder amount</td>
                        <td><i>String</i><br /><br />12-character numeric<br /><br />smallest discrete unit of foreign currency</td>
                        <td><code>{CODES.cardholder_amount[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>cardholder currency code</td>
                        <td><i>String</i><br /><br />3-character numeric</td>
                        <td><code>{CODES.cardholder_currency_code[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>3-D Secure 2.0 -specific fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>3DS version<p className="note"><b>NOTE: </b>Mandatory for transactions using 3-D Secure version 2.0+ </p></td>
                        <td><i>String</i><br /><br />1-character numeric</td>
                        <td><code>{CODES.TDS_version[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>3DS server transaction ID<p className="note"><b>NOTE: </b>Mandatory for transactions using 3-D Secure version 2.0+ – obtained from the Cavv Lookup request or MPI 3DS Authentication request </p></td>
                        <td><i>String</i><br /><br />36-character numeric</td>
                        <td><code>{CODES.server_transaction_ID[progLangId]}</code></td>
                    </tr>
                </table>
                
                <h3 style={{ marginTop: '7vh'}}>MCP Purchase with 3-D Secure and Vault transaction request fields – Optional</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>customer ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric<p className="note"><b>NOTE: </b> {"Some special characters are not allowed: < > $ % = ? ^ { } [ ] \\"}</p></td>
                        <td><code>{CODES.customer_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>dynamic descriptor</td>
                        <td><i>String</i><br /><br />20-character alphanumeric<br /><br />total of 22 characters including your merchant name and separator<p className="note"><b>NOTE: </b> {"Some special characters are not allowed: < > $ % = ? ^ { } [ ] \\"}</p></td>
                        <td><code>{CODES.dynamic_descriptor[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>wallet indicator<br /></td>
                        <td><i>String</i><br /><br />3-character alphanumeric</td>
                        <td><code>{CODES.wallet_indicator[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>Credential on File Info<br />cof<br /><br /><p className="note"><b>NOTE: </b>This is a nested object within the transaction, and required when storing or using the customer's stored credentials. For information about fields in the Credential on FIle Info object, see Credential on File Info Object and Variables.</p></td>
                        <td><i>Object</i><br /><br />N/A</td>
                        <td><code>{CODES.Credential_Info[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>AVS Information</td>
                        <td><i>Object</i><br /><br />N/A</td>
                        <td><code>{CODES.AVS_Information[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>CVD Information<br /></td>
                        <td><i>Object</i><br /><br />N/A</td>
                        <td><code>{CODES.CVD_Information[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>3-D Secure 2.0 -specific fields – Optional</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>DS transaction ID</td>
                        <td><i>String</i><br /><br />36-character alphanumeric</td>
                        <td><code>{CODES.DS_transaction_ID[progLangId]}</code></td>
                    </tr>
                </table>
            </div>
        );
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { storeId, apiToken, orderId, pan, expdate, amount, currency, cavv, mcpRateToken } = state.mcp.main.config;
    return { mode, storeId, apiToken, orderId, pan, expdate, amount, currency, cavv, mcpRateToken, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {makePurchase3DSVault, updateOrderId})(PurchaseWith3DSVault)
